// Document file type categories
export enum DOCUMENT_FILE_TYPE_CATEGORIES {
    Jpeg = 1,
    Png = 2,
    Pdf = 3,
}

export const getFileTypeByCategory = (category: DOCUMENT_FILE_TYPE_CATEGORIES) => {
    switch (category) {
        case DOCUMENT_FILE_TYPE_CATEGORIES.Jpeg:
            return 'jpeg';
        case DOCUMENT_FILE_TYPE_CATEGORIES.Png:
            return 'png';
        case DOCUMENT_FILE_TYPE_CATEGORIES.Pdf:
            return 'pdf';
        default:
            return '';
    }
}